<template>
  <InputPicker
    button-label="Insert canned response"
    button-fill="far"
    button-icon="comment"
    :trigger="trigger"
    :textarea="textarea"
    :items="cannedResponses"
    :anchorSearchToKeyStart="true"
    @input="$emit('input', $event)"
    @cancelTrigger="(refocus) => $emit('cancelTrigger', refocus)"
  />
</template>

<script>
import InputPicker from "@/FormWidgets/WidgetInputArea/components/InputPicker.vue";

export default {
  name: "CannedResponsePicker",
  components: {InputPicker},
  // Vue 3:
  // emits: ['input', 'cancelTrigger'],
  props: {
    textarea: Function,
    trigger: {
      type: [KeyboardEvent, Boolean],
      default: false,
    },
    cannedResponses: {
      type: Object,
      required: true,
    },
  },
}
</script>
